import { render, staticRenderFns } from "./BaseSegmentedButton.vue?vue&type=template&id=49151c45&scoped=true&"
import script from "./BaseSegmentedButton.vue?vue&type=script&lang=ts&"
export * from "./BaseSegmentedButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSegmentedButton.vue?vue&type=style&index=0&id=49151c45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49151c45",
  null
  
)

export default component.exports